import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Link } from '~/components/Link/src/Link';
import styles from './RewardsGetStartedTermsLink.module.css';
const TERMS_HREF = '/legal/byway-club-terms-and-conditions';
export const RewardsGetStartedTermsLink = () => {
  const $ = _c(4);
  const t = useTranslations("account");
  let t0;
  if ($[0] !== t) {
    t0 = t("rewards_getstarted_terms");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Link href={TERMS_HREF} hasUnderline={true} className={styles.termsLink} data-test-id="RewardsGetStartedTermsLink">{t0}</Link>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};